<script setup lang="ts">
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import {
  OrderPayLater as OrderAndPayLaterIcon,
  PayToOrder as PayToOrderIcon
} from '@xpos/icons-svg';
import { OrderFlow } from '@posx/core';

const { t } = useI18n();

const $emit = defineEmits(['change', 'update:modelValue', 'close', 'confirm']);
const $props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
});

const visible = ref($props.modelValue);

watch(
  () => $props.modelValue,
  (newVal: boolean) => {
    visible.value = newVal;
  }
);

const handleClose = () => {
  $emit('change', false);
  $emit('update:modelValue', false);
  $emit('close', false);
};

const handleOptionSelect = (option: OrderFlow) => {
  $emit('confirm', option);
  handleClose();
};
</script>

<template>
  <x-dialog
    v-model="visible"
    width="770px"
    :title="t('orderQrOptions.title')"
    :before-close="handleClose"
    @close="handleClose"
    :close-on-click-modal="false"
  >
        <div class="w-full flex flex-col">
      <!-- Order Flow label positioned as per Figma -->
      <div class="mb-[5px]">
        <span class="text-[14px] font-medium text-[#3A3A3A] font-['Barlow'] leading-[130%]">{{ t('orderQrOptions.orderFlow') }}</span>
      </div>

      <!-- Option Buttons with 5px gap as per Figma -->
      <div class="flex gap-[5px]">
          <x-button
            type="primary"
            square
            size="large"
            @click="handleOptionSelect(OrderFlow.OrderFirstAndPayLater)"
          >
            <el-icon size="50">
              <component :is="OrderAndPayLaterIcon" />
            </el-icon>
            <template #footer>
              <span>{{ t('orderQrOptions.options.orderAndPayLater') }}</span>
            </template>
          </x-button>

          <x-button
            type="primary"
            square
            size="large"
            @click="handleOptionSelect(OrderFlow.PayToOrder)"
          >
            <el-icon size="50">
              <component :is="PayToOrderIcon" />
            </el-icon>
            <template #footer>
              <span>{{ t('orderQrOptions.options.payToOrder') }}</span>
            </template>
          </x-button>
      </div>
    </div>
  </x-dialog>
</template>

<style lang="scss" scoped>
.el-button + .el-button {
  margin-left: 0;
}
</style>
